export default __webpack_public_path__ + "static/a2067c38-35db-4f0a-a58b-e55955d13d15-facb4b4517692c6c76d236e13da9ae10.woff2";